@if (showContent) {
  <div class="login-page">
    <div class="row" (keyup)="loginOnEnter($event)">
      <div style="width: 600px; margin-left: auto; margin-right: auto; position: absolute; top: 20%; left: calc(50% - 300px)">
        <div class="panel panel-default">
          <div class="panel-heading">
            <div class="panel-title">
              <img src="/assets/UVexplorerServerLogo.png" class="logo"/>
            </div>
          </div>
          <div class="panel-body">
            @if (success) {
              <div class="alert alert-primary">Login Successful - Redirecting</div>
            }
            @if (error) {
              <div class="alert alert-danger">{{error}}</div>
            }
            <fieldset>
              @if (displayUserType) {
                <div class="mb-3 row">
                  <div style="text-align: center;">
                    <label for="UserType" class="login-label">Account Type:</label>
                    <select class="form-control login-input" [(ngModel)]="userType" name="UserType" (change)="onUserTypeChanged()"
                      style="width: 200px;">
                      @for (value of userTypes; track value) {
                        <option value="{{value}}" [attr.selected]="(value == userType) ? '' : null">
                          {{authTypeLabel(value)}}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              }
              @if (displayUsername) {
                <div class="mb-3 row">
                  <div style="text-align: center;">
                    <label for="Username" class="login-label login-field-label">Username:</label>
                    <input class="form-control login-input login-field" placeholder="Username" name="Username" autofocus [(ngModel)]="username">
                  </div>
                </div>
              }
              @if (displayPassword) {
                <div class="mb-3 row">
                  <div style="text-align: center;">
                    <label for="Password" class="login-label login-field-label">Password:</label>
                    <input type="password" class="form-control login-input login-field" placeholder="Password" name="Password"
                      autocomplete="off" [(ngModel)]="password">
                    </div>
                  </div>
                }
                @if (displayDomainName) {
                  <div class="mb-3 row">
                    <div style="text-align: center;">
                      <label for="DomainName" class="login-label login-field-label">Domain Name:</label>
                      <select class="form-control login-input login-field" [(ngModel)]="domainName" name="DomainName">
                        @for (value of domainNames; track value) {
                          <option value="{{value}}"
                            [attr.selected]="(value == domainName) ? '' : null">
                            {{value}}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                }
                @if (displayLoginButton) {
                  <div class="mb-3 row" style="display: block; padding-top: 10px; text-align: center;">
                    <button pButton style="width: auto;" [disabled]="!enableLogin" (click)="login()" label="Login"></button>
                  </div>
                }
                @if (displayGoogleWorkspaceLoginButton) {
                  <div class="mb-3 row"
                    style="display: block; padding-top: 10px; text-align: center;">
                    <iframe #signinframe sandbox="allow-popups allow-same-origin allow-scripts allow-top-navigation"
                      style="width: 200px; height: 50px; border: none; overflow: hidden;">
                    </iframe>
                  </div>
                }
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

